/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getLabPrescriptions } from 'app/entities/lab-prescription/lab-prescription.reducer';
import { getEntities as getPatientProcedureOrders } from 'app/entities/patient-procedure-order/patient-procedure-order.reducer';
import { createEntity, getEntity, reset, updateEntity } from './patient-procedure-investigation.reducer';

export const PatientProcedureInvestigationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const labPrescriptions = useAppSelector(state => state.labPrescription.entities);
  const patientProcedureOrders = useAppSelector(state => state.patientProcedureOrder.entities);
  const patientProcedureInvestigationEntity = useAppSelector(state => state.patientProcedureInvestigation.entity);
  const loading = useAppSelector(state => state.patientProcedureInvestigation.loading);
  const updating = useAppSelector(state => state.patientProcedureInvestigation.updating);
  const updateSuccess = useAppSelector(state => state.patientProcedureInvestigation.updateSuccess);

  const handleClose = () => {
    navigate(`/patient-procedure-investigation${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getLabPrescriptions({}));
    dispatch(getPatientProcedureOrders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...patientProcedureInvestigationEntity,
      ...values,
      labPres: labPrescriptions.find(it => it.id.toString() === values.labPres?.toString()),
      order: patientProcedureOrders.find(it => it.id.toString() === values.order?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...patientProcedureInvestigationEntity,
          labPres: patientProcedureInvestigationEntity?.labPres?.id,
          order: patientProcedureInvestigationEntity?.order?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.patientProcedureInvestigation.home.createOrEditLabel"
            data-cy="PatientProcedureInvestigationCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.home.createOrEditLabel">
              Create or edit a PatientProcedureInvestigation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-procedure-investigation-id"
                  label={translate('tinyMedicRestApp.patientProcedureInvestigation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureInvestigation.active')}
                id="patient-procedure-investigation-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureInvestigation.cursor')}
                id="patient-procedure-investigation-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureInvestigation.lastupdated')}
                id="patient-procedure-investigation-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureInvestigation.microSec')}
                id="patient-procedure-investigation-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureInvestigation.timestampentry')}
                id="patient-procedure-investigation-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="patient-procedure-investigation-labPres"
                name="labPres"
                data-cy="labPres"
                label={translate('tinyMedicRestApp.patientProcedureInvestigation.labPres')}
                type="select"
                required
              >
                <option value="" key="0" />
                {labPrescriptions
                  ? labPrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="patient-procedure-investigation-order"
                name="order"
                data-cy="order"
                label={translate('tinyMedicRestApp.patientProcedureInvestigation.order')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedureOrders
                  ? patientProcedureOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/patient-procedure-investigation"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientProcedureInvestigationUpdate;
